import {
  RecommendationEntity,
  RecommendationsRepositoryContract,
} from "@features/recommendations/domain";
import { BaseRepository, getDaysSince } from "@features/shared/data";
import {
  RECOMMENDATIONS_API,
  RECOMMENDATIONS_DAYS_THRESHOLD,
  RECOMMENDATIONS_PAGE_SIZE,
} from "../constants";
import { mapRecommendation } from "../mappers";
import { RecommendationModel } from "../models";

export class RecommendationsRepository
  extends BaseRepository
  implements RecommendationsRepositoryContract
{
  public async getRecommendations(
    pageNumber: number,
    pageSize?: number,
  ): Promise<RecommendationEntity[]> {
    const { data } = await this.http.get<RecommendationModel[]>(
      `${RECOMMENDATIONS_API.getRecommendations}`,
      {
        params: {
          page: pageNumber,
          pageSize: pageSize ?? RECOMMENDATIONS_PAGE_SIZE,
        },
      },
    );

    return (
      data
        .map(mapRecommendation)
        // Filter out recommendations that are older than 60 days
        .filter(
          recommendation =>
            getDaysSince(recommendation.createdAt) <=
            RECOMMENDATIONS_DAYS_THRESHOLD,
        )
    );
  }
}
